export const REGEX_VALID_IMAGE_FORMATS = /gif|jpe?g|[^a]png|webp/i